<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12">
                <inter-input class="mb-3"
                             label="Vecchia Password"
                             v-model="passwords.old"
                             icon="key"
                             type="password"
                             :error="errors.old">
                </inter-input>
            </b-col>
            <b-col cols="12">
                <inter-input class="mb-3"
                             label="Nuova Password"
                             v-model="passwords.new"
                             type="password"
                             icon="key"
                             :error="errors.new">
                </inter-input>
            </b-col>
            <b-col cols="12">
                <inter-input
                             label="Conferma Password"
                             v-model="passwords.confirm"
                             type="password"
                             icon="key"
                             :error="errors.confirm">
                </inter-input>
            </b-col>
        </b-row>

    </b-container>

</template>

<script>
    import InterInput from "../../components/form/inter-input/InterInput";
    import _ from "lodash";

    export default {
        name: "FormUpdatePassword",
        components: {InterInput},
        data() {
            return {
                errors: {},
            }
        },
        props: {
            passwords: {
                type: Object,
                default: () => {
                }
            },
        },
        methods: {
            validate: function() {
                this.errors = {};
                if(this.passwords.old === '') {
                    this.errors.old = true;
                    this.$bvToast.toast('La password vecchia non può essere vuota', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                }

                if(this.passwords.new === '') {
                    this.errors.new = true;
                    this.$bvToast.toast('La password nuova non può essere vuota', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                }

                if(this.passwords.new !== this.passwords.confirm ) {
                    this.errors.new = true;
                    this.errors.confirm = true;
                    this.$bvToast.toast('La password di conferma non corrisponde', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                }

                return _.isEmpty(this.errors);
            }
        }
    }
</script>

<style scoped>

</style>
